// extracted by mini-css-extract-plugin
export default {"container":"style_container__A73NQ","partners-table-container":"style_partners-table-container__MOmH4"};